import { apiRequestWithChecks } from "./api";

export const templateCategories = {
    getAll: function (token) {
        return apiRequestWithChecks("GET", "/api/templates/categories", {
            "Authorization": "Bearer " + token
        });
    },

    add: function (token, name) {
        return apiRequestWithChecks("POST", "/api/templates/categories", {
            "Authorization": "Bearer " + token
        }, { name });
    },

    edit: function (token, id, name) {
        return apiRequestWithChecks("PUT", "/api/templates/categories", {
            "Authorization": "Bearer " + token
        }, { id, name });
    },

    delete: function (token, id) {
        return apiRequestWithChecks("DELETE", `/api/templates/categories/${id}`, {
            "Authorization": "Bearer " + token
        });
    },

    getUsage: function (token, id) {
        return apiRequestWithChecks("GET", `/api/templates/categories/${id}/usage`, {
            "Authorization": "Bearer " + token
        });
    },
};
